module.exports = __webpack_public_path__ + "img/logo-preto-cna.4a6704b4.svg";